import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { useSummaryVersion } from '../../hooks/useSummaryVersion';
import Asset from './Asset';

const AssetContainer = ({ id, ...props }) => {
    const { asset, loading, error } = useSummaryVersion(id);
    if (loading) return <div>Loading asset...</div>;
    if (error) return <div>Error loading asset</div>;
    if (!asset) return <div>No asset data available</div>;
    return <Asset asset={{ ...asset }} {...props} />;
};

AssetContainer.propTypes = {
    id: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => ({
    embeds: ownProps.embeds ? state.embeds.concat(ownProps.embeds) : state.embeds,
});

const enhance = compose(connect(mapStateToProps));

export default enhance(AssetContainer);
